export const onlyNumbersRegexDE = /^[0-9]*([,][0-9]*)?$/;
export const onlyNumbersRegexEN = /^[0-9]*([.][0-9]*)?$/;
export const onlyNumbers = /\D/;
